import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  countUsers(context) {
    const query = QuerySerialize(context.state.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`users/count/?${query}`)
        .then(response => {
          context.commit('SET_USERS_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchUsers(context) {
    const query = QuerySerialize(context.state.query)
    const skip = context.state.skip
    const limit = context.state.limit
    return new Promise((resolve, reject) => {
      axios
        .get(`users/?skip=${skip}&limit=${limit}&${query}`)
        .then(response => {
          context.commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`users/${userId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`users/${userId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editUser(context, user) {
    return new Promise((resolve, reject) => {
      axios
        .put(`users/${user.id}`, user.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
